<template>
    <slot></slot>
</template>

<script>

export default {

    name: 'ReadMoreButton',

    props: ['reference'],

    data() {
        return {
            isOpen: false,
            isHidden: false,
        }
    },

    created() {

    },

    mounted() {

        this.Bus.on('toggle-read-more', (data) => {
            if (data.reference === this.reference) {
                this.toggle()
            }
        });
    },

    methods: {

        toggle() {

            let clickedOverlay = document.querySelector('div[data-reference="overlay-' + this.reference +'"]');
            let parentSection = document.querySelector('section[data-reference="' + this.reference +'"]');
            let targetSection = parentSection.querySelector(':first-child');
            let contentHeight = targetSection.scrollHeight;

            if (targetSection) {
                if (! this.isOpen) {
                    targetSection.style.maxHeight = contentHeight + 'px';
                }

                this.isOpen = ! this.isOpen;

                clickedOverlay.classList.add('opacity-0');

                //hide toggle button after fading out
                setTimeout(() => {
                    clickedOverlay.classList.add('hidden');
                }, 300); // Replace 2000 with actual API call or data fetching
            }
        },
    }
};
</script>
